module.exports = __webpack_public_path__ + "static/media/vacancyPeriodHint-2.312e297f.jpg";